import React, { useState, useEffect } from "react";
import ReactIdSwiper from "react-id-swiper";

export default (props) => {
  // //console.log(props);
  var data = props.data;
  // Swiper instance
  const [swiper, updateSwiper] = useState(null);
  // Slides current index
  const [currentIndex, updateCurrentIndex] = useState(0);
  var elePagi = ".swiper-pagination";
  if (props.page == "home-banners") {
    elePagi = ".swiper-pagination.swiper-pagination-white";
  }
  var params = {};
  // Params definition
 (props.page == "dr-carousel-unit")
    params = {
      loop: true,
        slidesPerView: "auto",
        slidesPerView: 3.9,
        spaceBetween: 20,
         breakpoints: {
        767: {
          slidesPerView: 2.8,
          spaceBetween: 12
        },
      },
      getSwiper: updateSwiper // Get swiper instance callback
    }
  

  // Manipulate swiper from outside
  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  // Add eventlisteners for swiper after initializing
  useEffect(() => {
    if (swiper !== null) {
      swiper.on("slideChange", () => updateCurrentIndex(swiper.realIndex));
    }

    return () => {
      if (swiper !== null) {
        swiper.off("slideChange", () => updateCurrentIndex(swiper.realIndex));
      }
    };
  }, [swiper]);

  return (
    <div>
      <ReactIdSwiper {...params}>
        {data && data.map((item, idx) => (
          (props.page == "dr-carousel-unit" ?
            <div className="swiper-slide_feed" data-key={idx} key={idx}>
                <div className="baby_week_main_content">
                      <a href={item.menuUrl} className="dev_baby_opacity_main" aria-label={`Go to ${item.title}`}>
                       <div className="baby_opacity_main">

                       <img className="gtm-baby-this-week" src={item.imageUrl}  alt={item.title} title={item.title}
                               onError={(e) => { e.target.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/no-image.png"}}
                               />
                      <div id="gtm-baby-this-weektitle" style={{ 'display': 'none' }}> {item.title} </div>
                     </div>
                     <div className="baby_week_name_content">
                        <div className="baby_name_text M15_white"> {item.title} </div>

                     </div>
                       </a>

                </div>
            </div>
            :
            <div className="swiper-slide_feed" key={idx}>
              <img src="https://bbcdnlivemumbai.s3.ap-south-1.amazonaws.com/brainbees/community/memoryimages/1584339297p4706331.jpeg" alt="" />
            </div>
          )
        ))}
      </ReactIdSwiper>
      <div className="buttons buttons-list" style={{ display: "none" }}>
        <button id="prevSlide" className="button is-primary" onClick={goPrev} aria-label="Previous Slide">
          Prev
        </button>
        <button id="nextSlide" className="button is-primary" onClick={goNext} aria-label="Next Slide">
          Next
        </button>
      </div>
    </div>
  );
};
